/* eslint-disable sonarjs/no-duplicate-string */
const sidebarList = [
  {
    id: 1,
    key: 'profile',
    label: 'Profil Perusahaan',
    description: 'Nama Perusahaan, Tipe Inventory, PIC Astro, dan lainnya',
    isSelected: true,
  },
  {
    id: 5,
    key: 'contacts',
    label: 'Kontak',
    description: 'Role PIC, Nama, Email, Nomor Telepon',
    isSelected: false,
  },
  {
    id: 6,
    key: 'locations',
    label: 'Alamat',
    description: 'Provinsi, Kota, Kode Pos, dan lainnya',
    isSelected: false,
  },
  {
    id: 3,
    key: 'shipping',
    label: 'Pengiriman & Jadwal',
    description: 'Jadwal PO, Inbound, Pengiriman, dan lainnya',
    isSelected: false,
  },
  {
    id: 2,
    key: 'finance',
    label: 'Informasi Keuangan',
    description: 'NPWP, Status PKP, Akun Bank, dan lainnya',
    isSelected: false,
  },
  {
    id: 4,
    key: 'documents',
    label: 'Dokumen',
    description: 'Upload KTP, NIB dan lainnya',
    isSelected: false,
  },
]

export default sidebarList
